import { Controller } from '@hotwired/stimulus';

export default class ModalActionController extends Controller {
  static targets = ['dialog', 'frame'];
  static values = {
    size: String,
    fullscreen: Boolean,
  };

  connect() {
    // Initialize Bootstrap modal
    this.modal = new bootstrap.Modal(this.element);

    // Listen for Bootstrap modal events
    this.element.addEventListener('show.bs.modal', this.handleShow.bind(this));
    this.element.addEventListener(
      'hide.bs.modal',
      this.handleModalClose.bind(this),
    );
  }

  disconnect() {
    // Clean up event listeners
    this.element.removeEventListener(
      'show.bs.modal',
      this.handleShow.bind(this),
    );
    this.element.removeEventListener(
      'hide.bs.modal',
      this.handleModalClose.bind(this),
    );
    this.modal.dispose();
  }

  handleShow(event) {
    const button = event.relatedTarget;
    if (!button) return;

    // Get data from trigger button
    const url = button.getAttribute('data-modal-url');
    const size = button.getAttribute('data-modal-size');
    const fullscreen = button.getAttribute('data-modal-fullscreen') === 'true';

    // Set modal size and fullscreen
    if (this.hasDialogTarget) {
      this.dialogTarget.className = 'modal-dialog';
      if (size) {
        this.dialogTarget.classList.add(`modal-${size}`);
      }
      if (fullscreen) {
        this.dialogTarget.classList.add('modal-fullscreen');
      }
    }

    // Load content into Turbo Frame
    if (this.hasFrameTarget && url) {
      this.frameTarget.setAttribute('src', url);
    }
  }

  handleModalClose(event) {
    // Remove focus from any elements inside the modal before it closes
    if (
      document.activeElement &&
      this.element.contains(document.activeElement)
    ) {
      document.activeElement.blur();
    }

    // Clear the frame source when modal closes
    if (this.hasFrameTarget) {
      this.frameTarget.setAttribute('src', '');
    }
  }
}
